<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="父物料编码">
        <el-input v-model="query.materialCode" size="small" clearable style="width:150px" placeholder="父物料编码" />
      </el-form-item>
      <el-form-item label="父物料名称">
        <el-input v-model="query.materialName" size="small" clearable style="width:150px" placeholder="父物料名称" />
      </el-form-item>
      <el-form-item label="版本号">
        <el-input v-model="query.bomVersion" size="small" clearable style="width:150px" placeholder="版本号" />
      </el-form-item>
      <el-form-item>
        <el-button v-if="bomAuth('list')" type="primary" size="small" @click="search">查询</el-button>
      </el-form-item>
      <el-form-item><el-button size="small" @click="queryVisible = true">更多查询</el-button></el-form-item>
      <el-form-item><el-button size="small" @click="resetQuery">重置</el-button></el-form-item>
      <el-form-item v-if="moreQuerySummary"><span class="query-summary" :title="moreQuerySummary">{{ moreQuerySummary }}</span></el-form-item>
      <el-form-item>
        <el-button v-if="bomAuth('save')" type="primary" size="small" @click="openBatch()">新增BOM</el-button>
      </el-form-item>
      <el-form-item v-if="bomAuth('save')">
        <el-dropdown @command="handleImport">
          <el-button type="primary" size="small">导入<i class="el-icon-arrow-down el-icon--right" /></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="download">下载导入模板</el-dropdown-item>
            <el-dropdown-item command="upload">导入明细</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-upload ref="importUpload" style="display:none" :show-file-list="false" action="" :http-request="doImport" :before-upload="beforeImport" />
      </el-form-item>
      <el-form-item>
        <el-button v-if="bomAuth('list')" type="primary" size="small" @click="exportFile">导出</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="更多查询条件" :visible.sync="queryVisible" width="480px" append-to-body :close-on-click-modal="false">
      <el-form label-width="100px" label-position="right">
        <el-form-item label="启用状态">
          <el-select v-model="query.enabled" size="small" clearable placeholder="全部" style="width:100%">
            <el-option label="启用" value="1" /><el-option label="禁用" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="query.approveStatus" size="small" clearable placeholder="全部" style="width:100%">
            <el-option label="未审批" value="0" /><el-option label="已审批" value="2" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="queryVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="queryVisible = false; search()">确定</el-button>
      </span>
    </el-dialog>

    <el-table ref="bomTable" :data="pageVersions" border v-loading="loading" highlight-current-row class="bom-version-table" style="width:100%"
      :header-cell-style="headStyle" @row-click="selectVersion" @row-dblclick="openTree">
      <el-table-column prop="materialCode" label="父物料编码" header-align="center" align="left" min-width="160" />
      <el-table-column prop="materialName" label="父物料名称" header-align="center" align="left" min-width="180" show-overflow-tooltip />
      <el-table-column prop="bomVersion" label="版本号" header-align="center" align="center" width="100" />
      <el-table-column prop="nodeCount" label="子件总数" header-align="center" align="right" width="100" />
      <el-table-column prop="levelCount" label="层级深度" header-align="center" align="right" width="100" />
      <el-table-column prop="enabled" label="启用状态" header-align="center" align="center" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.enabled === '1'" type="success" size="small">启用</el-tag>
          <el-tag v-else type="danger" size="small">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="approveStatus" label="审批状态" header-align="center" align="center" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.approveStatus === '2'" type="success" size="small">已审批</el-tag>
          <el-tag v-else type="info" size="small">未审批</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updateDate" label="修改日期" header-align="center" align="right" width="100">
        <template slot-scope="scope">{{ (scope.row.updateDate || '').substr(0, 10) }}</template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" @size-change="val => { pageSize = val; pageIndex = 1 }"
      @current-change="val => pageIndex = val" :current-page="pageIndex" :page-sizes="[20, 50, 100]"
      :page-size="pageSize" :total="filteredVersions.length" layout="total, sizes, prev, pager, next, jumper" />

    <el-dialog :visible.sync="treeVisible" width="78%" :close-on-click-modal="false">
      <template slot="title">
        <span>查看BOM明细</span>
        <span v-if="treeVersion" class="title-actions">
          <el-button v-if="bomAuth('save')" type="primary" size="small" @click="editVersion(treeVersion)">修改</el-button>
          <el-button v-if="bomAuth('delete')" type="primary" size="small" @click="deleteVersion(treeVersion)">删除</el-button>
          <el-button v-if="bomAuth('update')" type="primary" size="small" @click="openApprove">审批版本</el-button>
          <el-button v-if="bomAuth('update')" type="primary" size="small" @click="unapprove">弃审批</el-button>
          <el-button v-if="bomAuth('update')" type="primary" size="small" @click="setEnabled('1')">启用版本</el-button>
          <el-button v-if="bomAuth('update')" type="primary" size="small" @click="setEnabled('0')">禁用版本</el-button>
          <el-button v-if="bomAuth('save')" type="primary" size="small" @click="copyVersion">复制版本</el-button>
        </span>
      </template>
      <el-form v-if="treeVersion" :inline="true" size="small" class="view-tree-version-bar">
        <el-form-item label="父物料"><span>{{ treeVersion.materialCode }} / {{ treeVersion.materialName }}</span></el-form-item>
        <el-form-item label="版本号"><span>{{ treeVersion.bomVersion || '—' }}</span></el-form-item>
        <el-form-item label="审批状态">
          <el-tag v-if="treeVersion.approveStatus === '2'" type="success" size="small">已审批</el-tag>
          <el-tag v-else type="info" size="small">未审批</el-tag>
        </el-form-item>
        <el-form-item label="生效开始"><span>{{ dateText(treeVersion.effectiveStartDate) }}</span></el-form-item>
        <el-form-item label="生效结束"><span>{{ dateText(treeVersion.effectiveEndDate) }}</span></el-form-item>
      </el-form>
      <el-form :inline="true" size="small" style="margin-bottom:10px">
        <el-form-item label="快速搜索">
          <el-input v-model.trim="treeKeyword" clearable placeholder="子件编码/子件名称" style="width:260px" />
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="treeOnlyLeaf">仅显示叶子节点</el-checkbox>
        </el-form-item>
      </el-form>
      <el-table :data="treeRows" border row-key="bomId" :default-expand-all="!treeOnlyLeaf" :tree-props="treeOnlyLeaf ? undefined : { children: 'children' }" style="width:100%" :header-cell-style="headStyle">
        <el-table-column prop="childMaterialCode" label="子件编码" header-align="center" align="left" min-width="160" />
        <el-table-column prop="childMaterialName" label="子件名称" header-align="center" align="left" min-width="180" show-overflow-tooltip />
        <el-table-column prop="childSpecs" label="规格型号" header-align="center" align="left" min-width="130" show-overflow-tooltip />
        <el-table-column prop="quantity" label="单位用量" header-align="center" align="right" width="100" />
        <el-table-column prop="loss" label="损耗率(%)" header-align="center" align="right" width="100" />
        <el-table-column prop="isSubstitute" label="替代料" header-align="center" align="center" width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isSubstitute === '1'" type="warning" size="small">是</el-tag>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="生效开始" header-align="center" align="center" width="110"><template slot-scope="scope">{{ dateText(scope.row.effectiveStartDate) }}</template></el-table-column>
        <el-table-column label="生效结束" header-align="center" align="center" width="110"><template slot-scope="scope">{{ dateText(scope.row.effectiveEndDate) }}</template></el-table-column>
      </el-table>
      <span slot="footer"><el-button @click="treeVisible = false">关闭</el-button></span>
    </el-dialog>

    <el-dialog :title="batchTitle" :close-on-click-modal="false" :visible.sync="batchVisible" width="980px">
      <el-form :inline="true">
        <el-form-item label="父物料">
          <el-select v-model="batch.parentMaterialId" filterable clearable placeholder="请选择父物料" style="width:280px" @change="loadBatchRows">
            <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
          </el-select>
        </el-form-item>
        <el-form-item label="版本号"><el-input v-model="batch.bomVersion" style="width:120px" @change="loadBatchRows" /></el-form-item>
        <el-form-item label="启用状态">
          <el-radio-group v-model="batch.enabled"><el-radio label="1">启用</el-radio><el-radio label="0">禁用</el-radio></el-radio-group>
        </el-form-item>
        <el-form-item><el-button size="small" @click="addRow">新增行</el-button></el-form-item>
      </el-form>
      <el-table :data="batch.rows" border height="360" :header-cell-style="headStyle">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column label="上级节点" width="200">
          <template slot-scope="scope">
            <el-select v-model="scope.row.parentId" filterable clearable size="small">
              <el-option label="顶级节点" value="" />
              <el-option v-for="item in parentOptions(scope.row)" :key="item.bomId" :label="item.childMaterialCode + ' / ' + item.childMaterialName" :value="item.bomId" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="子件" min-width="240">
          <template slot-scope="scope">
            <el-select v-model="scope.row.childMaterialId" filterable clearable size="small">
              <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="单位用量" width="130"><template slot-scope="scope"><el-input v-model="scope.row.quantity" size="small" /></template></el-table-column>
        <el-table-column label="损耗率(%)" width="120"><template slot-scope="scope"><el-input v-model="scope.row.loss" size="small" /></template></el-table-column>
        <el-table-column label="替代料" width="90">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isSubstitute" size="small"><el-option label="否" value="0" /><el-option label="是" value="1" /></el-select>
          </template>
        </el-table-column>
        <el-table-column label="替代组" width="120"><template slot-scope="scope"><el-input v-model="scope.row.substituteGroup" size="small" /></template></el-table-column>
        <el-table-column label="优先级" width="110"><template slot-scope="scope"><el-input-number v-model="scope.row.substitutePriority" :min="0" :step="1" size="small" /></template></el-table-column>
        <el-table-column label="生效开始" width="150"><template slot-scope="scope"><el-date-picker v-model="scope.row.effectiveStartDate" type="date" value-format="yyyy-MM-dd" size="small" style="width:130px" /></template></el-table-column>
        <el-table-column label="生效结束" width="150"><template slot-scope="scope"><el-date-picker v-model="scope.row.effectiveEndDate" type="date" value-format="yyyy-MM-dd" size="small" style="width:130px" /></template></el-table-column>
        <el-table-column label="排序" width="110"><template slot-scope="scope"><el-input-number v-model="scope.row.sort" :min="0" :step="1" size="small" /></template></el-table-column>
        <el-table-column label="备注" min-width="160"><template slot-scope="scope"><el-input v-model="scope.row.remark" size="small" /></template></el-table-column>
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" :disabled="scope.$index === 0" @click="moveRow(scope.$index, -1)">上移</el-button>
            <el-button type="text" size="small" :disabled="scope.$index === batch.rows.length - 1" @click="moveRow(scope.$index, 1)">下移</el-button>
            <el-button type="text" size="small" @click="removeRow(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="batchVisible = false">关闭</el-button>
        <el-button type="primary" @click="submitBatch">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="审批版本" :visible.sync="approveVisible" width="480px" append-to-body :close-on-click-modal="false">
      <el-form ref="approveForm" :model="approveForm" :rules="approveRules" label-width="110px" size="small">
        <el-form-item v-if="approveLabel" label="当前版本"><span>{{ approveLabel }}</span></el-form-item>
        <el-form-item label="生效开始日期" prop="effectiveStartDate">
          <el-date-picker v-model="approveForm.effectiveStartDate" type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期" style="width:100%" />
        </el-form-item>
        <el-form-item label="生效结束日期" prop="effectiveEndDate">
          <el-date-picker v-model="approveForm.effectiveEndDate" type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期" style="width:100%" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="approveVisible = false">取消</el-button>
        <el-button type="primary" @click="submitApprove">确定审批</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

function newId() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
}

export default {
  name: 'MaterialBom',
  data() {
    return {
      query: { materialCode: '', materialName: '', bomVersion: '', enabled: '', approveStatus: '' },
      queryVisible: false, lines: [], loading: false, pageIndex: 1, pageSize: 20, selected: null,
      treeVisible: false, treeVersion: null, treeKeyword: '', treeOnlyLeaf: false,
      materials: [], permCodes: [],
      batchVisible: false, batchTitle: '新增BOM', batchSkipLoad: false,
      batch: { parentMaterialId: '', bomVersion: 'V1', enabled: '1', rows: [], originIds: [] },
      approveVisible: false, approveLabel: '', approveForm: { effectiveStartDate: '', effectiveEndDate: '' },
      approveRules: {
        effectiveStartDate: [{ required: true, message: '请选择生效开始日期', trigger: 'change' }],
        effectiveEndDate: [{ required: true, message: '请选择生效结束日期', trigger: 'change' }]
      },
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  computed: {
    defaultBomType() { return '' },
    authPrefix() { return 'base:materialBom' },
    moreQuerySummary() {
      const parts = []
      if (this.query.enabled === '1') parts.push('启用状态：启用')
      if (this.query.enabled === '0') parts.push('启用状态：禁用')
      if (this.query.approveStatus === '0') parts.push('审批状态：未审批')
      if (this.query.approveStatus === '2') parts.push('审批状态：已审批')
      if (!parts.length) return ''
      return parts.length === 1 ? parts[0] : ('更多条件 ' + parts.length + ' 项')
    },
    versions() {
      const groups = {}
      this.lines.forEach(row => {
        const key = row.materialId + '|' + (row.bomVersion || '') + '|' + (row.bomType || this.defaultBomType || '')
        if (!groups[key]) {
          groups[key] = { ...row, bomType: row.bomType || this.defaultBomType || '', lines: [], nodeCount: 0, levelCount: 1, updateDate: '' }
        }
        const group = groups[key]
        group.lines.push(row)
        group.nodeCount += 1
        if ((row.updateDate || '') > (group.updateDate || '')) group.updateDate = row.updateDate
        if (!group.effectiveStartDate && row.effectiveStartDate) group.effectiveStartDate = row.effectiveStartDate
        if (!group.effectiveEndDate && row.effectiveEndDate) group.effectiveEndDate = row.effectiveEndDate
      })
      return Object.values(groups).map(group => {
        group.levelCount = this.levelCount(group.lines)
        return group
      })
    },
    filteredVersions() {
      const code = (this.query.materialCode || '').trim()
      const name = (this.query.materialName || '').trim()
      const version = (this.query.bomVersion || '').trim()
      return this.versions.filter(row => {
        if (code && String(row.materialCode || '').indexOf(code) < 0) return false
        if (name && String(row.materialName || '').indexOf(name) < 0) return false
        if (version && String(row.bomVersion || '').indexOf(version) < 0) return false
        if (this.query.enabled && row.enabled !== this.query.enabled) return false
        if (this.query.approveStatus && (row.approveStatus || '0') !== this.query.approveStatus) return false
        return true
      })
    },
    pageVersions() {
      const start = (this.pageIndex - 1) * this.pageSize
      return this.filteredVersions.slice(start, start + this.pageSize)
    },
    treeRows() {
      if (!this.treeVersion) return []
      const source = this.treeVersion.lines || []
      const keyword = (this.treeKeyword || '').toLowerCase()
      const childCount = {}
      source.forEach(item => { if (item.parentId) childCount[item.parentId] = (childCount[item.parentId] || 0) + 1 })
      const match = item => {
        const code = String(item.childMaterialCode || '').toLowerCase()
        const name = String(item.childMaterialName || '').toLowerCase()
        return !keyword || code.indexOf(keyword) >= 0 || name.indexOf(keyword) >= 0
      }
      if (this.treeOnlyLeaf) return source.filter(item => !childCount[item.bomId] && match(item))
      return this.toTree(source.filter(match))
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}); this.load(); this.loadMaterials() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    bomAuth(action) { return this.isAuth(this.authPrefix + ':' + action) },
    dateText(val) {
      if (!val) return '—'
      return String(val).substr(0, 10)
    },
    search() { this.pageIndex = 1; this.load() },
    resetQuery() {
      this.query = { materialCode: '', materialName: '', bomVersion: '', enabled: '', approveStatus: '' }
      this.search()
    },
    loadMaterials() {
      request.post('/base/material/page', { currentPage: 1, pageSize: 1000 }).then(res => {
        this.materials = (res.data && res.data.list) || []
      }).catch(() => {})
    },
    load() {
      this.loading = true
      const params = { materialId: '', bomVersion: '' }
      if (this.defaultBomType) params.bomType = this.defaultBomType
      request.get('/base/materialBom/list', { params })
        .then(res => { this.lines = res.data || []; this.refreshTree() })
        .catch(err => {
          this.lines = []
          this.$message.error((err && err.message) || '加载 BOM 失败')
        })
        .finally(() => { this.loading = false })
    },
    refreshTree() {
      if (!this.treeVersion) return
      const hit = this.versions.find(item => item.materialId === this.treeVersion.materialId && item.bomVersion === this.treeVersion.bomVersion
        && String(item.bomType || '') === String(this.treeVersion.bomType || this.defaultBomType || ''))
      this.treeVersion = hit || null
      if (!hit) this.treeVisible = false
    },
    selectVersion(row) { this.selected = row },
    levelCount(lines) {
      const byId = {}
      lines.forEach(row => { byId[row.bomId] = row })
      let max = 1
      lines.forEach(row => {
        let depth = 1
        let cursor = row
        const seen = {}
        while (cursor && cursor.parentId && byId[cursor.parentId] && !seen[cursor.bomId]) {
          seen[cursor.bomId] = true
          depth += 1
          cursor = byId[cursor.parentId]
        }
        if (depth > max) max = depth
      })
      return max
    },
    toTree(rows) {
      const map = {}
      rows.forEach(row => { map[row.bomId] = { ...row, children: [] } })
      const roots = []
      rows.forEach(row => {
        const node = map[row.bomId]
        if (row.parentId && map[row.parentId]) map[row.parentId].children.push(node)
        else roots.push(node)
      })
      return roots
    },
    openTree(row) {
      if (!this.bomAuth('list')) return
      this.treeVersion = row
      this.treeKeyword = ''
      this.treeOnlyLeaf = false
      this.treeVisible = true
    },
    context() {
      return (this.treeVisible && this.treeVersion) || this.selected
    },
    versionBomType(row) {
      return (row && row.bomType) || this.defaultBomType || ''
    },
    openBatch(rows, title) {
      // Material records may have been added in another tab since this page was mounted.
      this.loadMaterials()
      this.batchTitle = title || '新增BOM'
      this.batchSkipLoad = !!(rows && rows.length)
      this.batch = {
        parentMaterialId: rows && rows[0] ? (rows[0].materialId || '') : '',
        bomVersion: rows && rows[0] ? (rows[0].bomVersion || 'V1') : 'V1',
        enabled: rows && rows[0] ? (rows[0].enabled || '1') : '1',
        rows: rows && rows.length ? rows.map((row, idx) => this.normalizeRow(row, idx)) : [this.normalizeRow({}, 0)],
        originIds: rows ? rows.map(row => row.bomId).filter(Boolean) : []
      }
      this.batchVisible = true
    },
    editVersion(row) {
      if (!row) return
      if (row.approveStatus === '2') {
        this.$message.warning('当前版本已审批，不能维护明细，请先弃审批')
        return
      }
      const bomType = this.versionBomType(row)
      const current = (row.lines && row.lines.length) ? row.lines : this.lines.filter(item => item.materialId === row.materialId && item.bomVersion === row.bomVersion
        && (!bomType || String(item.bomType || bomType) === String(bomType)))
      this.treeVisible = false
      this.openBatch(current, '维护BOM明细')
      this.batch.parentMaterialId = row.materialId
      this.batch.bomVersion = row.bomVersion || 'V1'
      this.batch.enabled = row.enabled || '1'
    },
    normalizeRow(row, idx) {
      const item = {
        bomId: row.bomId || '',
        rowKey: row.bomId ? '' : (row.rowKey || newId()),
        parentId: row.parentId || '',
        childMaterialId: row.childMaterialId || '',
        quantity: row.quantity != null ? String(row.quantity) : '1',
        loss: row.loss != null ? String(row.loss) : '0',
        sort: row.sort != null ? Number(row.sort) : idx,
        isSubstitute: row.isSubstitute || '0',
        substituteGroup: row.substituteGroup || '',
        substitutePriority: row.substitutePriority != null ? Number(row.substitutePriority) : 0,
        effectiveStartDate: row.effectiveStartDate || '',
        effectiveEndDate: row.effectiveEndDate || '',
        remark: row.remark || '',
        materialId: row.materialId || ''
      }
      return item
    },
    rowKey(row) { return row.bomId || row.rowKey || '' },
    parentOptions(row) {
      const self = this.rowKey(row)
      const map = {}
      this.batch.rows.forEach((item, idx) => {
        const key = this.rowKey(item)
        if (!key || key === self || !item.childMaterialId) return
        const mat = this.materials.find(m => m.materialId === item.childMaterialId)
        map[key] = { bomId: key, childMaterialCode: mat ? mat.materialCode : ('行' + (idx + 1)), childMaterialName: mat ? mat.materialName : '' }
      })
      return Object.values(map)
    },
    addRow() { this.batch.rows.push(this.normalizeRow({}, this.batch.rows.length)) },
    removeRow(index) {
      const target = this.batch.rows[index]
      if (!target) return
      const keys = this.cascadeKeys(this.rowKey(target))
      this.batch.rows = this.batch.rows.filter(item => keys.indexOf(this.rowKey(item)) < 0)
      this.batch.rows.forEach((row, idx) => { row.sort = idx; if (row.parentId && keys.indexOf(row.parentId) >= 0) row.parentId = '' })
    },
    cascadeKeys(root) {
      const set = {}
      if (!root) return []
      set[root] = true
      let changed = true
      while (changed) {
        changed = false
        this.batch.rows.forEach(item => {
          const key = this.rowKey(item)
          if (!key || set[key]) return
          if (item.parentId && set[item.parentId]) { set[key] = true; changed = true }
        })
      }
      return Object.keys(set)
    },
    moveRow(index, step) {
      const next = index + step
      const current = this.batch.rows[index]
      this.$set(this.batch.rows, index, this.batch.rows[next])
      this.$set(this.batch.rows, next, current)
      this.batch.rows.forEach((row, idx) => { row.sort = idx })
    },
    loadBatchRows() {
      if (this.batchSkipLoad) { this.batchSkipLoad = false; return }
      if (!this.batch.parentMaterialId || !this.batch.bomVersion) return
      const bomType = this.defaultBomType
      const rows = this.lines.filter(item => item.materialId === this.batch.parentMaterialId && item.bomVersion === this.batch.bomVersion
        && (!bomType || String(item.bomType || bomType) === String(bomType)))
      if (rows.some(item => item.approveStatus === '2')) this.$message.warning('当前版本已审批，不能维护明细，请先弃审批')
      this.batch.originIds = rows.map(item => item.bomId).filter(Boolean)
      this.batch.rows = rows.length ? rows.map((row, idx) => this.normalizeRow(row, idx)) : [this.normalizeRow({}, 0)]
      if (rows[0]) this.batch.enabled = rows[0].enabled || this.batch.enabled
    },
    async submitBatch() {
      if (!this.batch.parentMaterialId) { this.$message.warning('请选择父物料'); return }
      if (!this.batch.bomVersion) { this.$message.warning('版本号不能为空'); return }
      const duplicate = {}
      for (let i = 0; i < this.batch.rows.length; i++) {
        const row = this.batch.rows[i]
        if (!row.childMaterialId) { this.$message.error('第' + (i + 1) + '行子件不能为空'); return }
        if (row.childMaterialId === this.batch.parentMaterialId) { this.$message.error('第' + (i + 1) + '行子件不能等于父物料'); return }
        const key = (row.parentId || 'root') + '_' + row.childMaterialId
        if (duplicate[key]) { this.$message.error('第' + (i + 1) + '行与第' + duplicate[key] + '行子件重复'); return }
        duplicate[key] = i + 1
      }
      try {
        const currentIds = this.batch.rows.map(item => item.bomId).filter(Boolean)
        const deleteIds = this.batch.originIds.filter(id => currentIds.indexOf(id) < 0)
        for (const id of deleteIds) await request.post('/base/materialBom/delete', { bomId: id })
        for (const row of this.batch.rows) {
          const payload = {
            bomId: row.bomId || row.rowKey,
            materialId: this.batch.parentMaterialId,
            childMaterialId: row.childMaterialId,
            parentId: row.parentId || '',
            quantity: row.quantity || 0,
            loss: row.loss || 0,
            sort: row.sort || 0,
            bomVersion: this.batch.bomVersion,
            bomType: this.defaultBomType || '',
            enabled: this.batch.enabled,
            isSubstitute: row.isSubstitute || '0',
            substituteGroup: row.substituteGroup || '',
            substitutePriority: row.substitutePriority || 0,
            effectiveStartDate: row.effectiveStartDate || '',
            effectiveEndDate: row.effectiveEndDate || '',
            remark: row.remark || ''
          }
          await request.post('/base/materialBom/' + (row.bomId && this.batch.originIds.indexOf(row.bomId) >= 0 ? 'update' : 'save'), payload)
          row.bomId = payload.bomId
        }
        this.$message.success('操作成功')
        this.batchVisible = false
        this.load()
      } catch (e) {
        this.$message.error((e && e.message) || '批量保存失败')
      }
    },
    deleteVersion(row) {
      if (!row || !row.materialId) return
      if (row.approveStatus === '2') { this.$message.warning('当前版本已审批，不能删除整版，请先弃审批'); return }
      this.$confirm('确定删除物料「' + (row.materialCode || '') + ' / ' + (row.materialName || '') + '」的版本「' + (row.bomVersion || '') + '」？将删除该版本下全部 BOM 明细，且不可恢复。', '删除版本', { type: 'warning' }).then(() => {
        request.post('/base/materialBom/deleteVersion', { materialId: row.materialId, bomVersion: row.bomVersion, bomType: this.versionBomType(row) }).then(() => {
          this.$message.success('版本已删除')
          this.treeVisible = false
          this.treeVersion = null
          this.selected = null
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    setEnabled(enabled) {
      const row = this.context()
      if (!row) return
      request.post('/base/materialBom/updateVersionEnabled', { materialId: row.materialId, bomVersion: row.bomVersion, enabled, bomType: this.versionBomType(row) }).then(() => {
        this.$message.success('操作成功')
        this.load()
      }).catch(() => {})
    },
    openApprove() {
      const row = this.context()
      if (!row) return
      const today = new Date()
      const end = new Date()
      end.setFullYear(end.getFullYear() + 1)
      const fmt = d => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0')
      this.approveLabel = (row.materialCode || '') + ' / ' + (row.bomVersion || '')
      this.approveForm = { effectiveStartDate: fmt(today), effectiveEndDate: fmt(end) }
      this.approveVisible = true
    },
    submitApprove() {
      const row = this.context()
      if (!row) return
      this.$refs.approveForm.validate(valid => {
        if (!valid) return
        if (this.approveForm.effectiveStartDate > this.approveForm.effectiveEndDate) {
          this.$message.warning('生效开始日期不能晚于结束日期')
          return
        }
        request.post('/base/materialBom/approveVersion', {
          materialId: row.materialId, bomVersion: row.bomVersion, bomType: this.versionBomType(row),
          effectiveStartDate: this.approveForm.effectiveStartDate, effectiveEndDate: this.approveForm.effectiveEndDate
        }).then(() => {
          this.$message.success('审批成功')
          this.approveVisible = false
          this.load()
        }).catch(() => {})
      })
    },
    unapprove() {
      const row = this.context()
      if (!row) return
      request.post('/base/materialBom/unapproveVersion', { materialId: row.materialId, bomVersion: row.bomVersion, bomType: this.versionBomType(row) }).then(() => {
        this.$message.success('弃审批成功')
        this.load()
      }).catch(() => {})
    },
    copyVersion() {
      const row = this.context()
      if (!row) return
      this.$prompt('请输入目标版本号（例如 V2）', '复制版本', { inputPlaceholder: '目标版本号' }).then(({ value }) => {
        const targetVersion = (value || '').trim()
        if (!targetVersion) { this.$message.warning('目标版本号不能为空'); return }
        request.post('/base/materialBom/copyVersion', { materialId: row.materialId, sourceVersion: row.bomVersion, targetVersion, bomType: this.versionBomType(row) }).then(() => {
          this.$message.success('复制成功')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    handleImport(command) {
      if (command === 'download') this.downloadTemplate()
      if (command === 'upload') this.$refs.importUpload.$el.querySelector('input').click()
    },
    downloadBlob(res, name) {
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = name
      a.click()
      window.URL.revokeObjectURL(url)
    },
    downloadTemplate() {
      request.get('/base/materialBom/importTemplate', { responseType: 'blob' }).then(res => this.downloadBlob(res, 'material_bom_import_template.xlsx')).catch(() => {})
    },
    beforeImport(file) {
      const ok = /\.xlsx$/i.test(file.name)
      if (!ok) this.$message.error('请上传xlsx文件')
      return ok
    },
    doImport(option) {
      const ctx = this.context()
      const form = new FormData()
      form.append('file', option.file)
      if (ctx && ctx.materialId) form.append('materialId', ctx.materialId)
      request.post('/base/materialBom/importRowsByMaterialCode', form).then(res => {
        const rows = res.data || []
        if (!rows.length) { this.$message.warning('导入数据为空'); return }
        this.openBatch(rows, '新增BOM')
        const rootCount = rows.filter(item => !item.parentId).length
        this.$message.success('导入成功，共' + rows.length + '条（顶级' + rootCount + '条，下级' + (rows.length - rootCount) + '条），请确认后提交')
      }).catch(() => {})
    },
    exportFile() {
      request.get('/base/materialBom/export', { params: this.query, responseType: 'blob' }).then(res => this.downloadBlob(res, 'material_bom_export.xlsx')).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 10px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.query-summary { max-width: 280px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #909399; font-size: 12px; }
.title-actions { float: right; margin-right: 28px; }
.title-actions .el-button { margin-left: 0; }
.view-tree-version-bar { margin-bottom: 8px; padding: 8px 12px; background: #f5f7fa; border-radius: 4px; }
.view-tree-version-bar .el-form-item { margin-bottom: 0; }
.bom-version-table >>> tbody tr { cursor: pointer; }
</style>
